import { render, staticRenderFns } from "./PageAppointmentsEditSettings.vue?vue&type=template&id=b7725e52&scoped=true&"
import script from "./PageAppointmentsEditSettings.vue?vue&type=script&lang=ts&"
export * from "./PageAppointmentsEditSettings.vue?vue&type=script&lang=ts&"
import style0 from "./PageAppointmentsEditSettings.vue?vue&type=style&index=0&id=b7725e52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7725e52",
  null
  
)

export default component.exports